import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { API_URL, scroll } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";

const Receipt = ({ location }) => {
	const [details, setDetails] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();

	useEffect(() => {
		scroll();
		init(location.state.id || "0", location.state.type || "");

		// eslint-disable-next-line
	}, []);

	const init = async (id, type) => {
		const url = new URL(`${API_URL}/receiptInit`);
		const params = {
			id,
			type,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setDetails({
					...json.data,
				});
				setAlert({});
			} else {
				history.push("/participating-charities");
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column">
			<Hdg section="Donations" />
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div className="alert well-sm alert-success" role="alert">
						<i className="fa fa-check-square-o" /> &nbsp;Champions{" "}
						<span style={{ fontStyle: "italic" }}>fore</span> Charity{" "}
						{details.type === "payment"
							? `Donation Pledge Payment Submitted`
							: `Donation Submitted`}
					</div>

					<p>
						Thank you! You have successfully submitted your{" "}
						{details.type === "payment" ? `pledge payment` : `donation`}. On
						behalf of Champions{" "}
						<span style={{ fontStyle: "italic" }}>fore</span> Charity and
						everyone associated with the Valero Texas Open, thank you for your
						support and contribution to help charities and schools within our
						community. A confirmation has also been sent to{" "}
						<strong>{details.email}</strong> and please click below to print or
						save{" "}
						{details.payment.descr === ""
							? "your donation fulfillment request letter"
							: "your tax thank you letter"}
						.
					</p>

					<div id="left-column" style={{ width: "100%", padding: "0" }}>
						<table className="approved">
							<thead>
								<tr>
									<th>No.</th>
									<th className="left">Donation Description</th>
									<th>Amount</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{details.donationId}</td>
									<td className="left">{details.items[0].descr}</td>
									<td className="right">{details.items[0].total}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<th
										colSpan="2"
										className="right"
										style={{ paddingRight: "10px" }}
									>
										TOTAL
									</th>
									<th className="right">{details.total}</th>
								</tr>
								<tr className={details.payment.descr === "" ? "hidden" : ""}>
									<td
										colSpan="2"
										className="right"
										style={{ paddingRight: "10px" }}
									>
										{`${details.payment.descr}`}
									</td>
									<td className="right ">{`${details.payment.amt}`}</td>
								</tr>
							</tfoot>
						</table>

						<div className="homebutton">
							<a
								href={`https://valerotexasopen.com/championsforecharity/donationprint/?${details.token}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								<i className="fa fa-print" /> &nbsp;
								{details.payment.descr === ""
									? "Donation Fulfillment Letter"
									: "Tax Thank You Letter"}
								<i className="fa fa-angle-right" />
							</a>
						</div>
					</div>
					<div
						id="right-column"
						style={{
							width: "0",
							paddingTop: "15px",
							paddingRight: "0",
							paddingLeft: "0",
						}}
					/>
				</>
			)}
		</div>
	);
};

export default Receipt;
